import { useContext } from 'react';

import type { ModuleContextValues } from '../../context/module-context/module-context';
import { ModuleContext } from '../../context/module-context/module-context';

export const useModuleContext = (): ModuleContextValues => {
  const context = useContext(ModuleContext);

  if (!context || !context.moduleContext) {
    throw new Error('No host context found. Please setup the ModuleContext');
  }

  return context;
};
